export const LABEL_TYPES = {
  OPERATION: 'FUNCTION',
  PROPERTY: 'PROPERTY',
  SECTION: 'API',
  CATEGORY: 'API',
  MAIN_ENTITY: 'OBJECT',
  WEBHOOK: 'WEBHOOK',
  EVENT: 'EVENT',
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
  HEAD: 'HEAD',
  OPTIONS: 'OPTIONS',
  MD: 'ARTICLE',
  DEPRECATED: 'DEPRECATED',
  TAG: 'API',
};
